import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./FeaturedProducts.css";
import { CATALOG_URL } from "../config/site";

export default function FeaturedProducts() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function loadProducts() {
      try {
        const response = await fetch(CATALOG_URL);
        const data = await response.json();

        const featuredProducts = data.products
          .filter((product) => product.active)
          .filter((product) => product.category === "magnet_accessories")
          .sort((a, b) => a.order - b.order);

        setProducts(featuredProducts);
      } catch (error) {
        // La tienda se oculta si el catalogo no esta disponible.
      }
    }

    loadProducts();
  }, []);

  const getProductLink = (product) => {
    return `/producto/${product.slug || product.id}`;
  };

  if (!products.length) {
    return null;
  }

  return (
    <section id="tienda" className="featured-products-section">
      <div className="featured-products-header">
        <p className="featured-products-eyebrow">Tienda</p>

        <h2>Productos para completar tus recuerdos</h2>

        <p>
          Accesorios, soportes y piezas especiales para colocar, regalar y
          disfrutar tus imanes personalizados.
        </p>
      </div>

      <div className="featured-products-grid">
        {products.map((product) => (
          <Link
            key={product.id}
            to={getProductLink(product)}
            className="featured-product-card"
          >
            {product.image && (
              <div className="featured-product-image">
                <img src={product.image} alt={product.name} loading="lazy" />
              </div>
            )}

            <div className="featured-product-content">
              <h3>{product.name}</h3>

              {product.shortDescription && <p>{product.shortDescription}</p>}

              <div className="featured-product-footer">
                <strong>{product.price.toFixed(2)} €</strong>
                <span>
                  Ver producto
                  <ArrowRight aria-hidden="true" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
